var _path, _path2, _circle, _circle2, _rect, _circle3, _circle4, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMood = function SvgMood(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M6 7v0a5 5 0 0 0-5 5v0a5 5 0 0 0 5 5v0a5 5 0 0 0 5-5v-.5",
    vectorEffect: "non-scaling-stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.13 12.5a2.8 2.8 0 0 0-2.65 1.8s.85-.59 2.65-.59c1.8 0 2.59.6 2.59.6s-.54-1.81-2.59-1.81Z",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.49,
    cy: 10.57,
    r: 0.5,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.67,
    vectorEffect: "non-scaling-stroke"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.51,
    cy: 10.57,
    r: 0.5,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.67,
    vectorEffect: "non-scaling-stroke"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    x: 7,
    y: 1,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 5,
    vectorEffect: "non-scaling-stroke"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.49,
    cy: 4.57,
    r: 0.5,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.67,
    vectorEffect: "non-scaling-stroke"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.51,
    cy: 4.57,
    r: 0.5,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.67,
    vectorEffect: "non-scaling-stroke"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.04 7.16c1.74.04 2.6-.55 2.6-.55s-.58 1.8-2.62 1.75C9.98 8.32 9.39 6.5 9.39 6.5s.83.62 2.65.66Z",
    clipRule: "evenodd"
  })));
};
export default SvgMood;